<template>
    <div class="slide">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title" :answers="questions.question.answers" :correctAnswer="questions.question.correctAnswer" :nextRoute="nextRoute" :current="3" :total="3" />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "rental",
            currentTrivia: 3,
            questions: {
                question: {
                    "title": "The 3 most common theft methods for boosters are:",
                    "answers": [
                        {"key": "A", "answer": "Box stuffing"},
                        {"key": "B", "answer": "Pretending to be an associate"},
                        {"key": "C", "answer": "Ticket switching"},
                        {"key": "D", "answer": "Walking out"}
                    ],
                    "correctAnswer": ["A", "C", "D"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>

</style>
